import type {ReactElement} from 'react';
import {useAppSelector} from '@/hooks';
import {FeedbackToast} from '@Components/feedback-toast/feedback-toast';
import {buildAiRedesignFeedbackToastProps} from '@Libraries/email-campaign-ai-redesign-library';

/**
 * Mounted host for the AI-redesign "AI just worked its magic" feedback toast. Reads the pending
 * toast from Redux (set by {@link aiRedesignEmailCampaign} on success) and renders the shared
 * FeedbackToast directly in the React tree — the React email maker never registers the legacy
 * `window.PMW.showFeedbackToast` global. Keyed on the redesign id so each run mounts a fresh,
 * re-animating instance.
 */
export function EmailMakerAiRedesignFeedbackToast(): ReactElement | null {
  const feedbackToast = useAppSelector((state) => state.emailMakerAiRedesignPromptBox.feedbackToast);

  if (!feedbackToast) {
    return null;
  }

  return <FeedbackToast key={feedbackToast.redesignHashedId} {...buildAiRedesignFeedbackToastProps(feedbackToast.redesignHashedId, feedbackToast.creditUsage)} />;
}
